import { InviteSearch } from "#webapp/src/components/invite-search";
import React from "react";
import { InviteSearchPerson } from "../../../invite-search";
import { Header, Loading, SlideLayout, Text } from "../../shared-components";

export const InviteSlide = ({
  onCheck,
  selectedInvitees,
  suggestions,
  loading,
}: {
  onCheck: (invitees: InviteSearchPerson[], checked: boolean) => void;
  selectedInvitees: InviteSearchPerson[];
  suggestions: InviteSearchPerson[];
  loading: boolean;
}) => {
  return loading ? (
    <Loading />
  ) : (
    <SlideLayout>
      <Header>Let's get your teammates on board</Header>
      <Text>
        We can't fix our workdays alone. Clockwise works best when it can harmonize an entire team's
        calendars.
      </Text>
      <div className="cw-w-full md:cw-w-[475px] cw-mt-8">
        <div className="cw-heading-sm cw-mb-2">Invite teammates </div>
        <InviteSearch
          selectedInvitees={selectedInvitees}
          suggestions={suggestions}
          onCheck={onCheck}
          trackingVariant="Onboarding"
        />
      </div>
    </SlideLayout>
  );
};
